// Central SEO configuration & verified business information.
// Only verified data is used here. Do NOT invent address, geo, ratings,
// opening hours, certifications or social profiles.

export const SITE_URL = "https://fedari.ae";
export const SITE_NAME = "Fedari Inspection";
export const OG_IMAGE = `${SITE_URL}/og-image.jpg`;
export const LOGO_URL = `${SITE_URL}/fedari-logo.png`;

export const BUSINESS = {
  brand: "Fedari Inspection",
  legalName: "FEDARI BUILDING INSPECTION L.L.C",
  licence: "1647070",
  email: "info@fedari.ae",
  phone: "+97142963910",
  phoneDisplay: "+971 4 296 3910",
  whatsapp: "971558650124",
  priceFrom: 799,
  currency: "AED",
  areaServed: ["Dubai", "Abu Dhabi", "Sharjah"],
};

// Absolute URL builder (non-trailing-slash convention, except root).
export const canonical = (path = "/") => {
  if (!path || path === "/") return `${SITE_URL}/`;
  const clean = "/" + path.replace(/^\/+|\/+$/g, "");
  return `${SITE_URL}${clean}`;
};

// Detect the react-snap prerender pass so runtime-only logic (e.g. preview
// noindex) is never baked into the production static HTML.
export const isSnapshot = () =>
  typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";

export const isProductionHost = () =>
  typeof window !== "undefined" && window.location.hostname === "fedari.ae";

// Public routes for the sitemap (canonical, indexable only).
// priority/changefreq are advisory hints.
export const PUBLIC_ROUTES = [
  { path: "/", priority: 1.0, changefreq: "weekly" },
  { path: "/property-snagging-dubai", priority: 0.9, changefreq: "monthly" },
  { path: "/property-inspection-uae", priority: 0.9, changefreq: "weekly" },
  { path: "/reinspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/handover-inspection-dubai", priority: 0.9, changefreq: "monthly" },
  { path: "/villa-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/apartment-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/resale-property-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/dlp-warranty-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/commercial-property-inspection-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/defect-cost-estimation-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/site-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/renovation-snagging-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/spa-inspection-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/mep-inspection-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/mold-inspection-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/pressure-smoke-testing-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/electrical-load-db-testing-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/hvac-duct-inspection-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/partners", priority: 0.6, changefreq: "monthly" },
  { path: "/property-inspection-abu-dhabi", priority: 0.7, changefreq: "monthly" },
  { path: "/property-inspection-sharjah", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-dubai-communities", priority: 0.8, changefreq: "monthly" },
  { path: "/property-snagging-al-furjan", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-sobha-hartland", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-central-park-city-walk", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-madinat-jumeirah-living", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-sobha-hartland-2", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-sobha-one", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-sobha-reserve", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-jumeirah-lake-towers", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-damac-lagoons", priority: 0.7, changefreq: "monthly" },
  { path: "/dlp-inspection-azizi-riviera", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-arabian-ranches-3", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-town-square-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-dubai-creek-harbour", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-dubai-hills-estate", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-nad-al-sheba-gardens", priority: 0.7, changefreq: "monthly" },
  { path: "/property-snagging-mudon-al-ranim", priority: 0.7, changefreq: "monthly" },
  { path: "/guides", priority: 0.7, changefreq: "weekly" },
  { path: "/guides/what-is-snagging-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/snagging-vs-handover-vs-dlp", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/snagging-cost-dubai-2026", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/room-by-room-snagging-checklist", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/when-to-book-snagging-inspection", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/send-snagging-report-to-developer", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/villa-vs-apartment-snagging", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/dlp-warranty-11-month-inspection", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/waterproofing-moisture-problems-uae", priority: 0.7, changefreq: "monthly" },
  { path: "/guides/property-snagging-report-dubai", priority: 0.7, changefreq: "monthly" },
  { path: "/services/overseas-property-inspection-dubai", priority: 0.8, changefreq: "monthly" },
  { path: "/communities/dubai-south-snagging-inspection", priority: 0.7, changefreq: "weekly" },
  { path: "/ar/guides", priority: 0.6, changefreq: "weekly" },
  { path: "/ar/guides/what-is-snagging-dubai", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/snagging-vs-handover-vs-dlp", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/snagging-cost-dubai-2026", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/room-by-room-snagging-checklist", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/when-to-book-snagging-inspection", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/send-snagging-report-to-developer", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/villa-vs-apartment-snagging", priority: 0.6, changefreq: "monthly" },
  { path: "/ar/guides/dlp-warranty-11-month-inspection", priority: 0.6, changefreq: "monthly" },
  { path: "/sample-snagging-report", priority: 0.7, changefreq: "monthly" },
  { path: "/inspection-tools", priority: 0.6, changefreq: "monthly" },
  { path: "/about-fedari", priority: 0.6, changefreq: "yearly" },
  { path: "/contact", priority: 0.7, changefreq: "yearly" },

  { path: "/cancellation-refund-policy", priority: 0.3, changefreq: "yearly" },
  { path: "/inspection-scope-exclusions", priority: 0.3, changefreq: "yearly" },
  { path: "/terms-and-conditions", priority: 0.3, changefreq: "yearly" },
  { path: "/ar/terms-and-conditions", priority: 0.3, changefreq: "yearly" },
  { path: "/privacy-policy", priority: 0.3, changefreq: "yearly" },
  { path: "/limitation-of-liability", priority: 0.3, changefreq: "yearly" },
];

// ---- JSON-LD builders (verified values only) ----

const CORE_SERVICES = [
  { name: "Property snagging inspection", path: "/property-snagging-dubai" },
  { name: "Pre-handover inspection", path: "/handover-inspection-dubai" },
  { name: "Villa inspection", path: "/villa-inspection-dubai" },
  { name: "Apartment inspection", path: "/apartment-inspection-dubai" },
  { name: "Resale / pre-purchase inspection", path: "/resale-property-inspection-dubai" },
  { name: "DLP / warranty inspection", path: "/dlp-warranty-inspection-dubai" },
  { name: "Commercial property inspection", path: "/commercial-property-inspection-dubai" },
  { name: "Defect cost estimation", path: "/defect-cost-estimation-dubai" },
  { name: "Site inspection", path: "/site-inspection-dubai" },
  { name: "Renovation snagging", path: "/renovation-snagging-dubai" },
  { name: "SPA based inspection", path: "/spa-inspection-dubai" },
  { name: "MEP inspection", path: "/mep-inspection-dubai" },
  { name: "Mold inspection", path: "/mold-inspection-dubai" },
  { name: "Pressure and smoke testing", path: "/pressure-smoke-testing-dubai" },
  { name: "Electrical load and DB testing", path: "/electrical-load-db-testing-dubai" },
  { name: "HVAC duct inspection", path: "/hvac-duct-inspection-dubai" },
];

const contactPoint = () => ({
  "@type": "ContactPoint",
  contactType: "customer service",
  telephone: BUSINESS.phone,
  email: BUSINESS.email,
  areaServed: BUSINESS.areaServed,
  availableLanguage: ["en", "ar"],
});

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE_URL}/#organization`,
  name: BUSINESS.brand,
  alternateName: "Fedari",
  legalName: BUSINESS.legalName,
  slogan: "Inspect Before You Accept.",
  url: `${SITE_URL}/`,
  logo: LOGO_URL,
  image: OG_IMAGE,
  email: BUSINESS.email,
  telephone: BUSINESS.phone,
  knowsLanguage: ["en", "ar"],
  sameAs: [`https://wa.me/${BUSINESS.whatsapp}`],
  contactPoint: [contactPoint()],
  identifier: { "@type": "PropertyValue", propertyID: "UAE Trade Licence", value: BUSINESS.licence },
  areaServed: BUSINESS.areaServed.map((a) => ({ "@type": "AdministrativeArea", name: a })),
});

export const professionalServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": `${SITE_URL}/#business`,
  name: BUSINESS.brand,
  legalName: BUSINESS.legalName,
  url: `${SITE_URL}/`,
  logo: LOGO_URL,
  image: OG_IMAGE,
  email: BUSINESS.email,
  telephone: BUSINESS.phone,
  priceRange: `From ${BUSINESS.currency} ${BUSINESS.priceFrom}`,
  knowsLanguage: ["en", "ar"],
  // The InterNACHI CPI credential belongs to the verified individual inspector
  // (see inspectorSchema), never to the company as a whole.
  employee: { "@id": `${SITE_URL}/#inspector-khalid-gaddur` },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Office 124, Regus Deira City Centre, City Centre Office Building, Port Saeed Road",
    addressLocality: "Deira, Dubai",
    addressCountry: "AE",
  },
  sameAs: [`https://wa.me/${BUSINESS.whatsapp}`],
  contactPoint: [contactPoint()],
  areaServed: BUSINESS.areaServed.map((a) => ({ "@type": "AdministrativeArea", name: a })),
  serviceType: "Property snagging and handover inspection",
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Property inspection services",
    itemListElement: CORE_SERVICES.map((s) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name: s.name, url: `${SITE_URL}${s.path}` },
    })),
  },
});

// Verified individual credential — Khalid Gaddur (NACHI26090103, verifiable at
// nachi.org). Modelled on a Person so a personal CPI credential never implies
// that the company, every inspector or every service is InterNACHI-certified.
export const inspectorSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Person",
  "@id": `${SITE_URL}/#inspector-khalid-gaddur`,
  name: "Khalid Gaddur",
  jobTitle: "Certified Professional Inspector (CPI)",
  worksFor: { "@id": `${SITE_URL}/#organization` },
  hasCredential: {
    "@type": "EducationalOccupationalCredential",
    credentialCategory: "Certification",
    name: "InterNACHI Certified Professional Inspector (CPI)",
    url: "https://www.nachi.org/verify?nachiid=NACHI26090103",
    recognizedBy: {
      "@type": "Organization",
      name: "International Association of Certified Home Inspectors",
      url: "https://www.nachi.org",
    },
  },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE_URL}/#website`,
  name: SITE_NAME,
  url: `${SITE_URL}/`,
  publisher: { "@id": `${SITE_URL}/#organization` },
  inLanguage: "en",
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: canonical(it.path),
  })),
});

export const serviceSchema = ({ name, description, serviceType, areaServed, path }) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  serviceType,
  url: canonical(path),
  provider: { "@type": "ProfessionalService", name: BUSINESS.brand, "@id": `${SITE_URL}/#business` },
  areaServed: (areaServed || BUSINESS.areaServed).map((a) => ({ "@type": "AdministrativeArea", name: a })),
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

// Article schema for the educational guides cluster. Authorship is the
// verified business entity; dates come from the guide content data.
export const articleSchema = ({ title, description, path, datePublished, dateModified, lang = "en" }) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: title,
  description,
  image: OG_IMAGE,
  mainEntityOfPage: { "@type": "WebPage", "@id": canonical(path) },
  author: { "@type": "Organization", name: BUSINESS.brand, "@id": `${SITE_URL}/#organization` },
  publisher: { "@id": `${SITE_URL}/#organization` },
  datePublished,
  dateModified: dateModified || datePublished,
  inLanguage: lang,
});

